module.exports = __webpack_public_path__ + "static/media/miracles_in_a_crisis.b74488f6.jpg";